import { render } from "./number-active-users.vue?vue&type=template&id=57951b2e"
import script from "./number-active-users.vue?vue&type=script&lang=ts"
export * from "./number-active-users.vue?vue&type=script&lang=ts"

import "./number-active-users.vue?vue&type=style&index=0&id=57951b2e&lang=less"
script.render = render

export default script